<section class="comp-file-explorer">
  <div class="page-help-topics">
    <button pButton type="button" class="icon-action" icon="fa fa-question-circle" pTooltip="View Help Topics" tooltipPosition="top" (click)="help.toggle($event)"></button>
    <p-overlayPanel styleClass="page-help-interior" #help>
      <h4><i class="fa fa-question-circle"></i> Help Topics</h4>
      <ul>
        <li><a (click)="helpDialogO()">How do I see an overview?</a></li>
        <li><a (click)="helpDialogP()">How do I upload and save a file?</a></li>
        <li><a (click)="helpDialogQ()">How do I replace a file?</a></li>
      </ul>
    </p-overlayPanel>
    <p-dialog [(visible)]="helpOverview" header="Show Me | Attachments &amp; Documents: Overview" [modal]="true" [responsive]="true">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/6gDrIKW8HSA?start=0;autoplay=1"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </p-dialog>
    <p-dialog [(visible)]="helpUploadFile" header="Show Me | Attachments &amp; Documents: Uploading &amp; Saving Files" [modal]="true" [responsive]="true">
      <iframe width="560" height="315" src="https://www.youtube.com/embed/6gDrIKW8HSA?start=140;autoplay=1"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </p-dialog>
    <p-dialog [(visible)]="helpReplaceFile" header="Show Me | Attachments &amp; Documents: Replacing Files" [modal]="true" [responsive]="true">
      <iframe *ngIf="helpReplaceFile" width="560" height="315" src="https://www.youtube.com/embed/6gDrIKW8HSA?start=190;autoplay=1"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    </p-dialog>
  </div>

  <!-- popup dialog for one file upload -->
  <p-dialog [(visible)]="displayMode===FileExplorerDisplay.Dialog&&displayUploadDialog"
            header="File Upload" [modal]="true" [responsive]="true" [style]="PrimeNgConfig.DialogStyle40">

    <div class="ui-grid-row">
      <span class="browse-button" style="pointer:cursor;">
        <p-fileUpload mode="basic" [accept]="AcceptableFileType" chooseLabel="Select File" chooseIcon="fa fa-disk" auto="true" styleClass="action-secondary"
                      (onSelect)="onSelectBrowseFile($event)"></p-fileUpload>
      </span>
    </div>

    <div *ngIf="selectedFileInBrowse?.name" class="ui-grid-row">
      <div class="ui-grid-col-3">
        <label>Selected File</label>
      </div>
      <div *ngIf="selectedFileInBrowse" class="ui-grid-col-4">{{selectedFileInBrowse.name}}</div>
      <div *ngIf="fileName&&docFile" class="ui-grid-col-5">will be saved as {{docFile.fileName}}</div>
    </div>

    <div style="text-align:right;padding:10px;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
              (click)="onClickCancelFileUploadDialog()" iconPos="left"></button>
      <button *ngIf="disableUpload" pButton type="button" class="button-action" icon="fa fa-check" label="Save"
              (click)="onClickCloseFileUploadDialog()" [disabled]="!docFile" iconPos="left"></button>
      <button *ngIf="!disableUpload" pButton type="button" class="button-action" icon="fa fa-cloud-upload" label="Upload"
              (click)="onClickUploadFiles()" [disabled]="!docFile" iconPos="left"></button>
    </div>
  </p-dialog>


  <!-- file explorer table -->
  <div *ngIf="displayMode===FileExplorerDisplay.FileExplorer" class="p-col-12">

    <app-data-table [columns]="tableColumns" [value]="docFiles" dataKey="fileName" sortField="poolType"
                    [enableAllRowExpansion]="true" [rowExpansionTemplate]="expansionTemplate"
                    [leftCaptionTemplate]="leftCaptionTemplate" [rightCaptionTemplate]="rightCaptionTemplate" [bodyTemplate]="bodyTemplate">

      <ng-template #leftCaptionTemplate>
        <button pButton type="button" class="action-secondary" icon="fa fa-refresh" label="Refresh" pTooltip="Refresh Files" tooltipPosition="top"
                (click)="getFileListForTransaction(txnTypeOrId, refId)">
        </button>
      </ng-template>

      <ng-template #rightCaptionTemplate>
        <p-fileUpload *ngIf="editable" #fileUpload
                      mode="basic" [accept]="AcceptableFileType" chooseLabel="Add File(s)" chooseIcon="fa fa-plus" styleClass="action-secondary"
                      [customUpload]="true" (onSelect)="onSelectBrowseFile($event);"></p-fileUpload>
      </ng-template>

      <ng-template #bodyTemplate let-row="row" let-columns="columns" let-expanded="expanded">
        <tr>
          <td *ngFor="let col of columns" [ngSwitch]="col.field">
            <span class="p-column-title">{{col.header}}</span>
            <span class="p-cell">
              <div *ngSwitchCase="'docTypeId'">
                <div *ngIf="editable && !row?.systemGenerated">
                  <p-dropdown [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{'width': '150px'}"
                              [options]="docTypeDropdown" [filter]="true"
                              [(ngModel)]="row.docTypeId"
                              (onChange)="onChangeDocType(row)">
                  </p-dropdown>
                </div>
                <!--              Display doctype as read only, for system generated file-->
                <div *ngIf="editable && row?.systemGenerated && row?.docTypeName">
                  {{row?.docTypeName | titleCase}}
                </div>
                <div *ngIf="!editable&&row?.docTypeName">
                  {{row?.docTypeName | titleCase}}
                </div>
              </div>
              <div *ngSwitchCase="'action'">
                <span class="browse-icon icon-position">
                  <p-fileUpload *ngIf="row?.id && editable && row?.permission?.canWrite" mode="basic" [accept]="AcceptableFileType"
                                chooseLabel="" pTooltip="Replace File"
                                tooltipPosition="top" auto="true"
                                (onSelect)="onSelectBrowseFile($event, row)">
                    <i class="fa fa-sync"></i>
                  </p-fileUpload>
                </span>
                <button *ngIf="row?.docAttributes&&row?.docAttributes?.length>0"
                        pButton class="icon-action icon-position" [icon]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"
                        pTooltip="Show File Info" tooltipPosition="top" style="font-size:20px"
                        href="#" [pRowToggler]="row">
                </button>
                <button *ngIf="editable && row?.permission?.canWrite"
                        pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Edit File Info" tooltipPosition="top"
                        (click)="onClickEditFileInfo(row)" iconPos="top">
                </button>
                <button *ngIf="row.id && row?.permission?.canRead"
                        pButton type="button" class="icon-action" icon="fa fa-eye" pTooltip="View File" tooltipPosition="top"
                        (click)="onClickViewFile(row)" iconPos="top">
                </button>
                <button *ngIf="row.id  && row?.permission?.canRead"
                        pButton type="button" class="icon-action" icon="fa fa-download" pTooltip="Download File" tooltipPosition="top"
                        (click)="onClickDownloadFile(row)" iconPos="top">
                </button>
                <button *ngIf="editable && row?.permission?.canDelete"
                        pButton type="button" class="icon-negative" icon="fa fa-trash" pTooltip="Delete File" tooltipPosition="top"
                        (click)="onClickDeleteFile(row)" iconPos="top">
                </button>
                <button *ngIf="editable && row.id  && row?.permission?.canPermit"
                        pButton type="button" icon="fa fa-cog" pTooltip="Edit permissions" tooltipPosition="top"
                        (click)="onClickEditFileSettings(row)">
                </button>
              </div>

              <div *ngSwitchDefault>
                <app-data-table-renderer [col]="col" [row]="row"></app-data-table-renderer>
              </div>
            </span>
          </td>
        </tr>
      </ng-template>

      <ng-template #expansionTemplate let-attributeRow="row" let-attributeColumns="columns">
        <tr>
          <td class="assessment-td" [attr.colspan]="attributeColumns.length">
            <app-data-table [columns]="attributeTableColumns" [value]="attributeRow.docAttributes"
                            [disableSearch]="true" [disablePagination]="true" [disableEmptyMessage]="true">
            </app-data-table>
          </td>
        </tr>
      </ng-template>

    </app-data-table>

    <div *ngIf="!doNotDisplayAdditionalSaveFilesButton && editable" class="p-col-12" style="text-align:right;margin-top:10px;">
      <button pButton type="button" class="button-action2" icon="fa fa-save" label="Save File(s)" pTooltip="Upload All" tooltipPosition="top"
              (click)="onClickUploadFiles()"
              [disabled]="docFiles?.length===0||!uploadAllEnabled">
      </button>
    </div>

  </div>

  <!-- dialog to gather file info attributes -->
  <p-dialog [(visible)]="displayFileInfoDialog" header="File Info"
            [modal]="true" [responsive]="true" [style]="PrimeNgConfig.DialogStyle40">
    <div *ngIf="selectedDocAttrs">
      <div *ngFor="let attrGrp of selectedDocAttrs" class="p-col-12">
        <div class="p-col-4">
          <label>{{attrGrp.attrName}}</label>
        </div>
        <div class="p-col-8">
          <input pInputText type="text" [style]="{'width':'100%'}" [(ngModel)]="attrGrp.attrValue"/>
        </div>
      </div>
    </div>
    <div *ngIf="!selectedDocAttrs||selectedDocAttrs.length<=0">
      There are no attributes associated with this file type. Please close the dialog to proceed.
    </div>
    <p-footer>
      <div style="padding:10px;text-align:right;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
                (click)="onClickCloseFileInfo()"></button>
        <button pButton type="button" class="button-action" icon="fa fa-save" label="Save"
                (click)="onClickSaveFileInfo()"></button>
      </div>
    </p-footer>

  </p-dialog>

  <!-- confirmation dialog -->
  <!--TODO: PrimeNg update, Use baseZindex property of confirm dialog to a manual value, so that if we are using file explorer in a dialog, dialog will use a
  less baseZindex value.-->
  <p-confirmDialog></p-confirmDialog>
  <app-file-permission-setting *ngIf="displayFileSettings"
                               [settingType]="FilePermissionSettingType.FilePermission" [selectedDocFileId]="selectedDocFileId"
                               (cancelEvent)="displayFileSettings=false"
                               (savePermissionEvent)="updateFileSettings($event)"></app-file-permission-setting>
  <div class="main-clear"></div>

</section>
